function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M6.98 10.823a.398.398 0 01-.267-.112l-2.36-2.542a.46.46 0 010-.62.396.396 0 01.536-.057l2.037 2.202 4.015-4.405c.154-.064.316-.102.482-.113a.498.498 0 01.321.34.388.388 0 01-.16.451l-4.337 4.744a.398.398 0 01-.267.112z",
  fill: "#fff"
});
function SvgTickmarki(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M8 16A8 8 0 108 0a8 8 0 000 16z",
    fill: props.color || 'currentColor'
  }), _ref);
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickmarki);
export default ForwardRef;